import type {OpeningCalendarData} from './types'

/**
 * @ngdoc service
 * @name openingCalendarDataService
 * @module portaro.components.opening-calendar
 *
 * @requires Restangular
 * @requires object:openingCalendarApiUrl
 *
 * @description
 * Data service for {@link component:kpOpeningCalendar}
 */

export default class OpeningCalendarDataService {
    static serviceName = 'openingCalendarDataService';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService, private openingCalendarApiUrl: string) {
    }

    /**
     * @ngdoc method
     * @name openingCalendarDataService#getOpeningHours
     *
     * @param {string=} url API URI. Default value is taken from {@link object:openingCalendarApiUrl}
     * @param {number=} departmentId id for requesting particular department opening hours
     *
     * @return {Promise} Calendar data
     */
    public async getOpeningHours(url: string = this.openingCalendarApiUrl, departmentId?: number): Promise<OpeningCalendarData> {
        return this.Restangular
            .one(url)
            .get({department: departmentId})
            .then((data) => data.plain());
    }
}